import {
  Component,
  ViewEncapsulation,
  OnInit,
  Input, EventEmitter, Output
} from '@angular/core';

import {Product} from '../models/product.model';
import {SelectionEvent} from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-variant',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'variant.template.html',
})

export class VariantComponent implements OnInit {
  @Input() public product: Product;
  @Input() public selected: string[];
  @Input() public showSku: boolean = true;
  @Output() selectedVariant = new EventEmitter<SelectionEvent>();

  selectedKeys:string[] = [];

  constructor() {
  }

  public onSelectionChanged(event:SelectionEvent) {
    this.selectedVariant.emit(event)
  }

  public ngOnInit(): void {
    this.selectedKeys.push(...this.selected);
  }
}
